<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogvtn.vue
*@ 컴포넌트설명 :[베트남] 예금 상품 > 금리 안내(개인고객)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
** 2022.11.11   최지영   호치민, 하노이 금리 분리
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit bar">
      <h6>{{ /*호치민*/ $t("VN1_지점명") }}</h6>
    </div>
    <!-- VN1 -->
    <div class="cont-tit">
      <h6>USD</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*상품*/ $t("MDEP-01-02-02-11") }}</th>
          <th scope="col">{{ /*기본금리*/ $t("MDEP-01-02-02-12") }}</th>
        </tr>
      </thead>
      <tbody v-if="vn1USD.length > 0">
        <tr v-for="(irUSD, i) in vn1USD" :key="i">
          <td v-if="vn1USDlist[i] !== 0" :rowspan="vn1USDlist[i]">
            {{
            lang == $config.LANG_KOR
            ? irUSD.prdctKndCtntKor
            : lang == $config.LANG_ENG
            ? irUSD.prdctKndCtntEng
            : irUSD.prdctKndCtntLcal
            }}
          </td>
          <td>{{ irUSD.bascIrtCtnt }}</td>
        </tr>
      </tbody>
    </table>

    <div class="cont-tit">
      <h6>VND</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*상품*/ $t("MDEP-01-02-02-11") }}</th>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">{{ /*기본금리*/ $t("MDEP-01-02-02-12") }}</th>
        </tr>
      </thead>
      <tbody v-if="vn1VND.length > 0">
        <tr v-for="(irVND, j) in vn1VND" :key="j">
          <td v-if="vn1USDlist[j] !== 0" :rowspan="vn1USDlist[j]">
            {{
            lang == $config.LANG_KOR
            ? irVND.prdctKndCtntKor
            : lang == $config.LANG_ENG
            ? irVND.prdctKndCtntEng
            : irVND.prdctKndCtntLcal
            }}
          </td>
          <td>
            {{
            lang == $config.LANG_KOR
            ? irVND.aplyTrmCtntKor
            : lang == $config.LANG_ENG
            ? irVND.aplyTrmCtntEng
            : irVND.aplyTrmCtntLcal
            }}
          </td>
          <td>{{ irVND.bascIrtCtnt }}</td>
        </tr>
      </tbody>
    </table>
    <div class="cont-tit bar">
      <h6>{{ /*하노이*/ $t("VN2_지점명") }}</h6>
    </div>
    <!-- VN2 -->
    <div class="cont-tit">
      <h6>USD</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*상품*/ $t("MDEP-01-02-02-11") }}</th>
          <th scope="col">{{ /*기본금리*/ $t("MDEP-01-02-02-12") }}</th>
        </tr>
      </thead>
      <tbody v-if="vn2USD.length > 0">
        <tr v-for="(irUSD, i) in vn2USD" :key="i">
          <td v-if="vn2USDlist[i] !== 0" :rowspan="vn2USDlist[i]">
            {{
            lang == $config.LANG_KOR
            ? irUSD.prdctKndCtntKor
            : lang == $config.LANG_ENG
            ? irUSD.prdctKndCtntEng
            : irUSD.prdctKndCtntLcal
            }}
          </td>
          <td>{{ irUSD.bascIrtCtnt }}</td>
        </tr>
      </tbody>
    </table>

    <div class="cont-tit">
      <h6>VND</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*상품*/ $t("MDEP-01-02-02-11") }}</th>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">{{ /*기본금리*/ $t("MDEP-01-02-02-12") }}</th>
        </tr>
      </thead>
      <tbody v-if="vn2VND.length > 0">
        <tr v-for="(irVND, j) in vn2VND" :key="j">
          <td v-if="vn2VNDlist[j] !== 0" :rowspan="vn2VNDlist[j]">
            {{
            lang == $config.LANG_KOR
            ? irVND.prdctKndCtntKor
            : lang == $config.LANG_ENG
            ? irVND.prdctKndCtntEng
            : irVND.prdctKndCtntLcal
            }}
          </td>
          <td>
            {{
            lang == $config.LANG_KOR
            ? irVND.aplyTrmCtntKor
            : lang == $config.LANG_ENG
            ? irVND.aplyTrmCtntEng
            : irVND.aplyTrmCtntLcal
            }}
          </td>
          <td>{{ irVND.bascIrtCtnt }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  data() {
    return {
      currentTab: 1,

      vn1USDlist: [],
      vn1VNDlist: [],

      vn2USDlist: [],
      vn2VNDlist: [],

      vn1USD: [],
      vn1VND: [],

      vn2USD: [],
      vn2VND: [],
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },

  created() {
    this.go();
  },
  methods: {
    go() {
      const path = "/deposit/interest/intRateVn12List";

      let params1 = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "",
          dpostLnDstcd: "D",
          operGroupCd: "VN1",
          ppsnCorpCtnt: "VN1PS",
          prdctKndCtnt: "",
        },
      };

      let params2 = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "",
          dpostLnDstcd: "D",
          operGroupCd: "VN2",
          ppsnCorpCtnt: "VN2PS",
          prdctKndCtnt: "",
        },
      };

      // vn1
      this.$post(path, params1, this.selectSucc1);

      // vn2
      this.$post(path, params2, this.selectSucc2);
    },
    selectSucc1(res) {
      this.vn1USD = res.interstList.filter(item => {
        return item.cncycd == "USD";
      });

      this.vn1VND = res.interstList.filter(item => {
        return item.cncycd == "VND";
      });

      let length = this.vn1USD.length;
      this.vn1USDlist = Array.from({ length }, () => 0);

      let target1 = undefined;
      let pointer1 = 0;

      for (let i = 0; i < length; i++) {
        if (target1 === this.vn1USD[i].prdctKndCtnt) {
          this.vn1USDlist[pointer1]++;
        } else {
          target1 = this.vn1USD[i].prdctKndCtnt;
          this.vn1USDlist[i]++;
          pointer1 = i;
        }
      }

      length = this.vn1VND.length;
      this.vn1VNDlist = Array.from({ length }, () => 0);

      let target2 = undefined;
      let pointer2 = 0;

      for (let i = 0; i < length; i++) {
        if (target2 === this.vn1VND[i].prdctKndCtnt) {
          this.vn1VNDlist[pointer2]++;
        } else {
          target2 = this.vn1VND[i].prdctKndCtnt;
          this.vn1VNDlist[i]++;
          pointer2 = i;
        }
      }
    },
    selectSucc2(res) {
      this.vn2USD = res.interstList.filter(item => {
        return item.cncycd == "USD";
      });

      this.vn2VND = res.interstList.filter(item => {
        return item.cncycd == "VND";
      });

      let length = this.vn2USD.length;
      this.vn2USDlist = Array.from({ length }, () => 0);

      let target1 = undefined;
      let pointer1 = 0;

      for (let i = 0; i < length; i++) {
        if (target1 === this.vn2USD[i].prdctKndCtnt) {
          this.vn2USDlist[pointer1]++;
        } else {
          target1 = this.vn2USD[i].prdctKndCtnt;
          this.vn2USDlist[i]++;
          pointer1 = i;
        }
      }

      length = this.vn2VND.length;
      this.vn2VNDlist = Array.from({ length }, () => 0);

      let target2 = undefined;
      let pointer2 = 0;

      for (let i = 0; i < length; i++) {
        if (target2 === this.vn2VND[i].prdctKndCtnt) {
          this.vn2VNDlist[pointer2]++;
        } else {
          target2 = this.vn2VND[i].prdctKndCtnt;
          this.vn2VNDlist[i]++;
          pointer2 = i;
        }
      }
    },
  },
};
</script>